export { QuestionCard } from './QuestionCard';
export { default } from './QuestionCard';
